import React from "react";
import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";

export function PageHeader({ eyebrow, title, subtitle, action }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
      <div>
        {eyebrow && <p className="label-eyebrow mb-2">{eyebrow}</p>}
        <h1 className="font-serif text-4xl md:text-5xl leading-none">{title}</h1>
        {subtitle && <p className="text-white/50 mt-3 max-w-2xl">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function StatCard({ label, value, accent, sub, icon: Icon }) {
  return (
    <div className="matte-card p-6">
      <div className="flex items-start justify-between">
        <p className="label-eyebrow">{label}</p>
        {Icon && <Icon size={18} className="text-gold/60" strokeWidth={1.6} />}
      </div>
      <p className={`font-mono text-3xl mt-3 ${accent ? "gold-text" : "text-cream"}`}>{value}</p>
      {sub && <p className="text-white/40 text-sm mt-1">{sub}</p>}
    </div>
  );
}

export function Loader({ label = "Loading…" }) {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-white/40">
      <Loader2 className="animate-spin text-gold mb-4" size={28} />
      <p className="text-sm">{label}</p>
    </div>
  );
}

export function EmptyState({ icon: Icon, title, body, action }) {
  return (
    <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}
      className="matte-card p-14 text-center flex flex-col items-center">
      {Icon && <div className="h-16 w-16 rounded-sm bg-gold/10 border border-gold/25 flex items-center justify-center text-gold mb-5"><Icon size={26} strokeWidth={1.4} /></div>}
      <h3 className="font-serif text-2xl">{title}</h3>
      {body && <p className="text-white/50 mt-2 max-w-md">{body}</p>}
      {action && <div className="mt-6">{action}</div>}
    </motion.div>
  );
}

export function Badge({ children, tone = "gold" }) {
  const tones = {
    gold: "bg-gold/10 text-gold border-gold/30",
    green: "bg-green-500/10 text-green-400 border-green-500/30",
    red: "bg-red-500/10 text-red-400 border-red-500/30",
    muted: "bg-white/5 text-white/50 border-white/10",
  };
  return <span className={`inline-flex items-center px-2.5 py-1 rounded-sm text-xs border ${tones[tone]}`}>{children}</span>;
}

export function DemoTag() {
  return <span className="inline-flex items-center px-2 py-0.5 rounded-sm text-[10px] uppercase tracking-widest bg-bronze/15 text-bronze border border-bronze/30">Demo</span>;
}

export function fcTone(pct, target = 28) {
  if (!pct) return "muted";
  return pct <= target ? "green" : pct <= target + 5 ? "gold" : "red";
}
